import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FilterState {
  filter: { sellerName: string; statusId: number };
}

const initialState: FilterState = {
  filter: { sellerName: "", statusId: 0 },
};

const filterSlice = createSlice({
  name: "filter",
  initialState,
  reducers: {
    setFilter: (state, action: PayloadAction<FilterState>) => {
      state.filter = action.payload.filter;
    },
  },
});

export const { setFilter } = filterSlice.actions;
export default filterSlice.reducer;
